var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "securities-component"
  }, [_vm._m(0), _c("div", {
    staticClass: "securities-component-img"
  }, [_c("img", {
    attrs: {
      src: _vm.img,
      alt: ""
    }
  })])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "securities-component-service"
  }, [_c("h3", [_vm._v("服务覆盖 "), _c("span", {
    staticClass: "number"
  }, [_vm._v("96%")]), _vm._v("的证券公司、"), _c("span", {
    staticClass: "number"
  }, [_vm._v("91%")]), _vm._v("的基金公司")]), _c("p", [_vm._v("同花顺已经与业内96%的券商，91%的基金公司，以及上千家合作伙伴共同为5亿投资者，提供包含股票、基金、期货、黄金、港美股等全投资品种服务。")])]);
}];
render._withStripped = true;
export { render, staticRenderFns };